import React from 'react';
import ReactDOM from 'react-dom';
import SingleSelect from '../../components/single-select/SingleSelect';
import LabelMap from '../../types/label-map/LabelMap';
import {getUrlHash, setUrlHash} from "../../utils/url-hash";

export default function ProductOptionHandler(options) {
    let selectedOptionId = options.length === 0 ? null :
        (options.some(t => t.id === getDefaultOptionId()) ? getDefaultOptionId() : options[0].id);

    let listeners = [];

    function trigger() {
        listeners.map(fn => fn());
    }

    function setSelectedOptionId(value) {
        selectedOptionId = value;
        saveDefaultOptionId(selectedOptionId);
        trigger();
    }

    this.getSelectedOptionId = () => {
        return selectedOptionId;
    };

    this.getSelectedOption = () => {
        return options.find(t => t.id === selectedOptionId);
    };

    this.addListener = (fn) => {
        if (!listeners.includes(fn)) {
            listeners.push(fn);
        }
    };

    this.removeListener = (fn) => {
        if (listeners.includes(fn)) {
            listeners.splice(listeners.indexOf(fn), 1);
        }
    };

    this.renderSelectBox = (container) => {
        ReactDOM.render(<SingleSelect
            options={new LabelMap(options.map(t => [t.id, t.name]))}
            defaultValue={selectedOptionId}
            onChange={setSelectedOptionId}
            appearance="box-accent"
        />, container);
    };
}

function getDefaultOptionId() {
    const hash = getUrlHash('optionId');
    return hash ? Number(hash) : null;
}

function saveDefaultOptionId(optionId) {
    return setUrlHash('optionId', optionId);
}
